export default "__VITE_ASSET__BY0UeRqR__"